//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import { mapState } from 'vuex'
    import ImageSrcsetMixin from '~/mixins/ImageSrcsetMixin';
    import userChecks from '~/mixins/userChecks';
    import mobilePlaylist from "~/components/content/show/mobilePlaylist";
    export default {
        mixins: [ImageSrcsetMixin, userChecks],
        async fetch() {
            this.$store.commit('mxmStore/clearStream');
            await Promise.all([ 
                this.$store.dispatch('resourcesStore/getResource', {
                    slug: this.$route.params.show,
                    query: this.queries.show
                }),
                this.$store.dispatch('bannerStore/getBanner', 'resource')
                ])
        },
        data() { 
            return {
                favorite: false,
                kind: false,
                read: {
                  text: 'Lees meer',
                  active: false  
              } 
          }
      },
      head() {
        return {
            title: this.showSingle.title + ' | ' + process.env.APP_TITLE,
            meta: [
                { hid: 'og:url', name: 'og:url', content: process.env.FE_URL + '/shows/' + this.showSingle.slug},
                { hid: 'og:title', name: 'og:title', content: this.showSingle.title},
                { hid: 'og:description', name: 'og:description', content: this.showSingle.excerpt},
                { hid: 'title', name: 'title', content: this.showSingle.title},
                { hid: 'description', name: 'description', content: this.showSingle.excerpt},
                { hid: 'og:type', name: 'og:type', content: 'video.movie'},
                { hid: 'og:image', name: 'og:image', content: this.showSingle.thumb},
                ]
        }
    },
    mounted() {
        if (this.showSingle) {
            this.checkFavorite();
        }
    },
    components: {
        dummy: () => import('~/components/content/dummy/showResource_dummy.vue'),
        breadcrumbs: () => import('~/components/breadcrumbs'),
        maxXsPlayer: () => import('~/components/maxxXsPlayer'),
        gallery: () => import('~/components/content/show/gallery_show'),
        readmore: () => import('~/components/content/show/readmore_show'),
        more: () => import('~/components/content/show/more'),
        playlist: () => import('~/components/content/show/playlist'),
        banner: () => import('~/components/banner.vue'),
        Paywall: () => import('~/components/payment/module.vue'),
        mobilePlaylist: () => import('~/components/content/show/mobilePlaylist')
    },
    computed: {
        ...mapState({
            queries: ({ resourcesStore: {queries} }) => queries,
            access: ({ resourcesStore: {access} }) => access,
            showSingle: ({ resourcesStore: {showSingle} }) => showSingle,
            modal: ({ modalStore: {modal} }) => modal,
            loading: ({ resourcesStore: {loading} }) => loading,
            playerOptions: ({ mxmStore: {playerOptions} }) => playerOptions,
            stream: ({ mxmStore: {stream} }) => stream,
            killStream: ({ mxmStore: {killStream} }) => killStream,
            playerStatus: ({ mxmStore: {playerStatus} }) => playerStatus,
            playerState: ({ mxmStore: {playerState} }) => playerState,
        })
    },
    watch: {
        stream: function() {
            if (this.stream.location == 'episode' && this.stream.ITEM && this.stream.ITEM.LINKS) {
                if (this.episode.images && this.episode.images.data && this.episode.images.data.thumb && this.episode.images.data.thumb[0]) {
                    var thumb = this.$config.cdn + this.episode.images.data.thumb[0].path;
                } else {
                    var thumb = this.$config.cdn + this.$config.errorimg;
                }
                let playerOptions = {
                    autoplay: true,
                    poster: thumb
                }
                this.$store.commit('mxmStore/updatePlayerOptions', playerOptions);
                this.$store.commit('mxmStore/setPlayerType', this.stream.type);
            }
        },
        killStream: function() {
            var phone_stream_id = this.getCookie('phone_stream_id');
            if (this.killStream == true && phone_stream_id) {
              this.doKillStream('phone');
          }
      }
  },
  methods: {
    checkFavorite() {
        if (this.$auth.loggedIn && this.hasFavoriteResource('show')) {
            var self = this;
            this.userFavoriteResources('show').forEach(function(favorite) { 
                if (self.showSingle.id === favorite.id) {
                    self.favorite = true;
                }
            })
        }
    },
    toggleFavo() {
        if (!this.$auth.loggedIn) {
            var notificationObj = [];
            notificationObj.type = 'info';
            notificationObj.message = 'Je kan alleen favorieten toevoegen als je bent ingelogd.';
            return this.$store.commit('notificationStore/setNotification', notificationObj, { root: true });
        }
        let data = {
            resource_id: this.showSingle.id,
            subscribe: 1
        };
        if (this.$auth.loggedIn) {
            data.user_id = this.$auth.user.id;
        } else {
            var notificationObj = [];
            notificationObj.type = 'info';
            notificationObj.message = 'Je moet inloggen om afleveringen aan je favorieten toe te voegen.';
            this.$store.commit('notificationStore/setNotification', notificationObj, { root: true });
            return false;    
        }
        if (this.favorite) {
            data.subscribe = 0;
            this.favorite = false;
        } else {
            this.favorite = true;
        }
        this.$store.dispatch('accountStore/toggleFavorite', data);
    },
    readmore() {
        if (!this.$root.isMobile) {
            return this.$store.commit('modalStore/setModal', 'readmore');
        }
        this.read.active = !this.read.active;
        if (this.read.active) {
            this.read.text = 'Lees minder'
        } else {
            this.read.text = 'Lees meer'
        }
    },
    loadTrailer(videoId) {
        console.log('loadTrailer');
        this.$store.commit('mxmStore/clearStream');
        this.kind = false;
        var dataObj = {
            video_id: videoId,
            resource_id: this.showSingle.id,
            type: 'trailer',
            location: 'episode',
            product_type: 'free'
        };
        if (this.$store.state.auth.loggedIn) {
            dataObj.user_id = this.$store.state.auth.user.id;
        }
        this.$store.dispatch('mxmStore/getStream', dataObj)
    },
    setStatus(status){
        this.$store.commit('mxmStore/setPlayerStatus', status)
    },
    doKillStream(type) {
      if (type == 'phone') {
        var notificationObj = [];
        notificationObj.type = 'warning';
        notificationObj.message = 'De verbinding is verbroken. Verder kijken? Bel dan opnieuw.';
        this.$store.commit('notificationStore/setNotification', notificationObj, { root: true });    
        document.cookie = "phone_stream_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        this.$store.commit('showStore/setPpmAccess', false)
        var self = this;
        setTimeout(function() {
          self.$router.go();
      }, 3000);
    }
},
}
}
